import { render, staticRenderFns } from "./LayoutChat.vue?vue&type=template&id=0d761402"
import script from "./LayoutChat.vue?vue&type=script&lang=js"
export * from "./LayoutChat.vue?vue&type=script&lang=js"
import style0 from "./LayoutChat.vue?vue&type=style&index=0&id=0d761402&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports